import * as articles from 'translations/reference/en';
import { isArticleForExp } from 'interpret/stdFnDesc';
import { START_CONTEXT_ARTICLE } from 'ui/constants';

const lowerCasedArticleNames = Object.keys(articles).map((articleName: string) => articleName.toLocaleLowerCase());

export const getExpArticleName = (exp?: string): string =>
  (exp && lowerCasedArticleNames.find((articleName: string) => isArticleForExp(exp, articleName))) ||
  START_CONTEXT_ARTICLE;
